import axios from 'axios';
import { isAfter, subMinutes } from 'date-fns';
import { INSURANCE_AUTO_AUTH_KEY } from '~/storage/constants';
import { LocalStorage } from '~/storage/LocalStorage';
import Env from '~/env';
import { MarisaAppUtils } from '~/utils/MarisaAppUtils';

type InsuranceAutoAuth = {
  access_token: string;
  expires_in: string;
};

interface GetTokenResponse {
  resultData: {
    token: string;
    tokenExpire: string;
  };
}

const INSURANCE_AUTO_URL = Env.INSURANCE_AUTO_URL;

export async function getInsuranceAutoTokenUseCase() {
  try {
    const [INSURANCE_AUTO_USER, INSURANCE_AUTO_PASS] =
      MarisaAppUtils.getOriginInsuranceApi();

    const insuranceAuth: InsuranceAutoAuth | undefined = await LocalStorage.get(
      INSURANCE_AUTO_AUTH_KEY
    );

    if (insuranceAuth) {
      // 30 minutes before the token expires
      const expiresInDate = subMinutes(new Date(insuranceAuth?.expires_in), 30);

      if (isAfter(expiresInDate, new Date())) {
        return insuranceAuth?.access_token;
      }
    }

    const response = await axios.post<GetTokenResponse>(
      `${INSURANCE_AUTO_URL}/auto/getToken`,
      {
        user: INSURANCE_AUTO_USER,
        pass: INSURANCE_AUTO_PASS,
      }
    );

    if (response.status !== 200) {
      throw new Error('Erro ao obter token');
    }

    LocalStorage.set(INSURANCE_AUTO_AUTH_KEY, {
      access_token: response.data.resultData.token,
      expires_in: response.data.resultData.tokenExpire,
    });

    return response.data.resultData.token;
  } catch (error) {
    console.log('get_insurance_auto_token', error);
    return null;
  }
}
